import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const ExtendedFieldTranslationKeys = {
  additionalDocuments: translationKey('extendedField_Additional_documents'),
  applicationNumber: translationKey('extendedField_Application_number'),
  circumstances: translationKey('extendedField_Circumstances'),
  completedAmount: translationKey('extendedField_Completed_amount'),
  constructionProductDocuments: translationKey('extendedField_Construction_product_documents'),
  costCode: translationKey('extendedField_Cost_code'),
  daysOfInabilityToWork: translationKey('extendedField_Days_of_inability_to_work'),
  decisionToImposeAFine: translationKey('extendedField_Decision_to_impose_a_fine'),
  delayReason: translationKey('extendedField_Delay_reason'),
  deviceDocuments: translationKey('extendedField_Device_documents'),
  effect: translationKey('extendedField_Effect'),
  employeeNumber: translationKey('extendedField_Employee_number'),
  employmentType: translationKey('extendedField_Employment_type'),
  environmentalAspectCategory: translationKey('extendedField_Environmental_aspect_category'),
  estimatedCost: translationKey('extendedField_Estimated_cost'),
  executedByCompanies: translationKey('extendedField_Executed_by_companies'),
  expectedFine: translationKey('extendedField_Expected_fine'),
  finalCompletionDate: translationKey('extendedField_Final_completion_date'),
  finalCorrectiveActionDescription: translationKey('extendedField_Final_corrective_action_description'),
  finalCost: translationKey('extendedField_Final_cost'),
  finalResponseToAuthorDate: translationKey('extendedField_Final_response_to_author_date'),
  finalStartDate: translationKey('extendedField_Final_start_date'),
  hazardCategory: translationKey('extendedField_Hazard_category'),
  immediateMeasures: translationKey('extendedField_Immediate_measures'),
  impact: translationKey('extendedField_Impact'),
  imposedFine: translationKey('extendedField_Imposed_fine'),
  injuredBodyParts: translationKey('extendedField_Injured_body_parts'),
  injuryTypes: translationKey('extendedField_Injury_types'),
  installationBasis: translationKey('extendedField_Installation_basis'),
  installationLocation: translationKey('extendedField_Installation_location'),
  issueVerification: translationKey('extendedField_Issue_verification'),
  numberOfEmployees: translationKey('extendedField_Number_of_employees'),
  personUnableToWork: translationKey('extendedField_Person_unable_to_work'),
  priority: translationKey('extendedField_Priority'),
  producerDistributor: translationKey('extendedField_Producer_distributor'),
  productType: translationKey('extendedField_Product_type'),
  projectStage: translationKey('extendedField_Project_stage'),
  proposedCorrectiveAction: translationKey('extendedField_Proposed_corrective_action'),
  proposedCorrectiveActionDescription: translationKey('extendedField_Proposed_corrective_action_description'),
  rejectionReason: translationKey('extendedField_Rejection_reason'),
  requirements: translationKey('extendedField_Requirements'),
  rootCause: translationKey('extendedField_Root_cause'),
  sickLeaveEndDate: translationKey('extendedField_Sick_leave_end_date'),
  sickLeaveStartDate: translationKey('extendedField_Sick_leave_start_date'),
  solutionMethod: translationKey('extendedField_Solution_method'),
  solutionProposal: translationKey('extendedField_Solution_proposal'),
  subcontractorRepresentative: translationKey('extendedField_Subcontractor_representative'),
  supervisor: translationKey('extendedField_Supervisor'),
  targetAmount: translationKey('extendedField_Target_amount'),
  targetCompletionDate: translationKey('extendedField_Target_completion_date'),
  targetResponseToAuthorDate: translationKey('extendedField_Target_response_to_author_date'),
  targetStartDate: translationKey('extendedField_Target_start_date'),
  typeModel: translationKey('extendedField_Type_model'),
  victim: translationKey('extendedField_Victim'),
  victimActivity: translationKey('extendedField_Victim_activity'),
  victimJobTitle: translationKey('extendedField_Victim_job_title'),
  workType: translationKey('extendedField_Work_type'),
  numberOfEmployees2: translationKey('extendedField_number_of_employees'),
  extendedfieldContaminatedSoilScale: translationKey('extendedfield_contaminated_soil_scale'),
  extendedfieldSoilLeakageScale: translationKey('extendedfield_soil_leakage_scale'),
  extendedfieldSpilledSubstance: translationKey('extendedfield_spilled_substance'),
  extendedfieldWaterLeakageScale: translationKey('extendedfield_water_leakage_scale'),
} as const satisfies Record<string, TranslationKey>;
